<div [id]="id" bsModal #modalControl="bs-modal" [config]="config" class="modal fade" role="dialog"
  (onHidden)="onHidden()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div>
        <a *ngIf="showClose && hideHeaderMobile" (click)="HideModalDialog($event)"> <i
            class="icon-close pull-right m-close hide-desktop" data-dismiss="modal" aria-label="Close"></i> </a>
      </div>
      <ng-content select=".modal-header">
      </ng-content>
      <ng-content select=".modal-body">
      </ng-content>
      <ng-content select=".modal-footer"></ng-content>
    </div>
  </div>
</div>